import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { mockData } from "./mock-data";

export default {
    title: "Components/Dynamic Href",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-dynamic-href",
    args: {
        endpoint: mockData.link,
    },
    argTypes: {
        endpoint: {
            control: {
                type: "select",
                options: [mockData.link, mockData.empty],
            },
        },
    },
};

const Template = ({ endpoint }) =>
    html`<ux-iws-dynamic-href endpoint="${endpoint}">
        <div slot="link">
            <a href="#" data-track-event-name="click_my_link"
                >This Link is dynamic</a
            >
        </div>
        <div slot="fallback">No link available</div>
    </ux-iws-dynamic-href>`;

export const Default = Template.bind({});
Default.args = {
    endpoint: mockData.link,
};

export const Empty = Template.bind({});
Empty.args = {
    endpoint: mockData.empty,
};
